import { TextHero } from 'components/TextHero'
import { BlogPosts } from 'components/Blog/BlogPosts'
import { BlogTags } from 'components/Blog/BlogTags'
import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { SeoFooter } from 'components/SeoFooter'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'

const BlogPage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'blog.meta.title' })}
        description={formatMessage({ id: 'blog.meta.description' })}
      />
      <Header bordered={false} />
      <TextHero title="Conoce Mérida, Descubre Yucatán" subtitle="Blog de Yucatán Premier" />
      <BlogTags />
      <BlogPosts />
      <SeoFooter />
      <Footer />
    </>
  )
}

export default BlogPage
